export default {"name":"NovaComponents-ListBox-gui-icu","comments":[],"messages":{"NovaComponents-ListBox-gui-icu.indentation.level.msg":"level {level}"}}